var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mt-swipe',{attrs:{"auto":4000}},_vm._l((_vm.swiperData),function(k){return _c('mt-swipe-item',{key:k.id},[_c('router-link',{attrs:{"to":{ name: '详情页'}}},[_c('img',{attrs:{"src":k.imgPath}})])],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }